import debounce from 'lodash.debounce';

import { AnalyticsEvent, trackAnalyticsEvent } from 'libs/analytics';

export const alertsEvents = {
  OPEN_PROJECT: 'alerts_open_project',
  PROJECTS_FILTER: 'alerts_projects_filter',
  LIST_OR_CARD: 'alerts_list_or_card',
  PROJECTS_BOOKMARK: 'alerts_projects_bookmark',
  PROJECTS_GROUP_BOOKMARK: 'alerts_projects_group_bookmark',
  FILTERS: 'alerts_filters',
  CHANGE_TAB: 'alerts_change_tab',
  CREATE_WITHOUT_ASSIGNING: 'alerts_create_without_assigning',
  CREATE_AND_ASSIGN: 'alerts_create_and_assign',
  UPDATE_WITHOUT_ASSIGNING: 'alerts_update_without_assigning',
  UPDATE_AND_ASSIGN: 'alerts_update_and_assign',
  ASSIGN: 'alerts_assign',
  UPDATE_TYPE: 'alerts_update_type',
  PRINT: 'alerts_print',
  DOWNLOAD: 'alerts_download',
} as const;

export const trackAlertsEvent = (
  action: (typeof alertsEvents)[keyof typeof alertsEvents],
  value?: number,
  textValue?: string
) => {
  const analyticsEvent: AnalyticsEvent = {
    action,
    category: 'alerts',
  };

  if (typeof value !== 'undefined') {
    analyticsEvent.event_value = value;
  }

  if (typeof textValue !== 'undefined') {
    analyticsEvent.event_text_value = textValue;
  }

  trackAnalyticsEvent(analyticsEvent);
};

export const debouncedTrackAlertsEvent = debounce(trackAlertsEvent, 500);
